import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgMenu(props: RootSvgProps) {
  return (
    <RootSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="24" height="24" rx="5" fill="#F3F2F1" />
      <rect x="9" y="6" width="10" height="2" fill="#2D2D2D" />
      <rect x="9" y="11" width="10" height="2" fill="#2D2D2D" />
      <rect x="9" y="16" width="10" height="2" fill="#2D2D2D" />
      <rect x="5" y="11" width="2" height="2" fill="#2D2D2D" />
      <rect x="5" y="16" width="2" height="2" fill="#2D2D2D" />
      <rect x="5" y="6" width="2" height="2" fill="#2D2D2D" />
    </RootSvg>
  );
}
